// Types
import { LayoutUtilsType } from './types/layout.utils.type';

const layoutIsFetching = ({ fetching, externalFetching }: LayoutUtilsType): boolean =>
  Boolean(fetching || externalFetching);

export { layoutIsFetching };
